import { ref } from "vue";
import { type Router } from "vue-router";

/** 在非 setup 中使用路由 */
export const routerNotInSetup = ref<Router>()
